export const INPUT_FILE_TYPE = {
  PDF: '.pdf,application/pdf',
  IMAGE: 'image/*',
  IMAGE_JPG: 'image/jpg',
  IMAGE_JPEG: 'image/jpeg',
  IMAGE_PNG: 'image/png',
  IMAGE_GIF: 'image/gif',
  IMAGE_BMP: 'image/bmp',
  IMAGE_TIFF: 'image/tiff',
  IMAGE_ICO: 'image/ico',
  IMAGE_WEBP: 'image/webp',
}
